<template>
  <div class="breadcrumb">
    <div class="breadcrumb-item" v-for="(item, index) in matchedRoutes" :key="index">
      <!-- 最后一个是蓝色，不能点击 -->
      <router-link v-if="index < matchedRoutes.length - 1" :to="getBreadcrumbTarget(item, index)">
        {{ item.meta.title }}
      </router-link>
      <span v-else class="blue">{{ item.meta.title }}</span>
      <!-- 最后一个不显示箭头 -->
      <img v-if="index < matchedRoutes.length - 1" src="@/assets/images/menu/right.png" alt="" />
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const matchedRoutes = computed(() => {
  return route.matched.filter(item => item.meta && item.meta.title)
})

const getBreadcrumbTarget = (item, index) => {
  const currentSourcePath = route.query.from
  const isParentBreadcrumb = index === matchedRoutes.value.length - 2

  if (
    typeof currentSourcePath === 'string' &&
    isParentBreadcrumb &&
    currentSourcePath.startsWith(`${item.path}/`)
  ) {
    return currentSourcePath
  }

  return item.path
}
</script>
<style lang="scss" scoped>
.breadcrumb {
  height: 100%;
  display: flex;
  align-items: center;

  .breadcrumb-item {
    display: flex;
    align-items: center;

    img {
      width: 5px;
      height: 8.33px;
      margin: 0 8px;
    }

    a {
      font-size: 18px;
      font-weight: bold;
      color: #0a1629;

      &:hover {
        // 蓝色
        color: #409eff;
      }
    }

    .blue {
      font-size: 18px;
      font-weight: bold;
      color: #409eff;
    }
  }
}
</style>
